import router from '@/router'
import { useStore} from 'vuex'
import { GetSysinfo } from '@/api'

router.beforeEach((to, from, next) => {
  const store = useStore()
  if(store.state.app.sysinfo!=={}){
    GetSysinfo().then(res=>{
      store.commit('app/SET_SYSINFO',res)
      document.title = store.state.app.sysinfo.title
      next()
    }).catch()
  }
})

router.afterEach(() => {
})
